import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const DocPreviewDialog = ({ open, onOpenChange, pages, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[94vh] w-[96vw] max-w-4xl overflow-y-auto bg-slate-100 p-4 sm:p-6" data-testid="doc-preview-dialog">
      <DialogHeader>
        <DialogTitle>Vista previa del documento</DialogTitle>
        <DialogDescription>Así se verá el PDF. La vista previa no se guarda en el historial.</DialogDescription>
      </DialogHeader>
      {loading ? (
        <div className="space-y-4" data-testid="doc-preview-loading">
          {[0, 1].map((i) => <div key={i} className="aspect-[612/792] w-full animate-pulse rounded-md bg-white" />)}
        </div>
      ) : (
        <div className="space-y-4" data-testid="doc-preview-pages">
          {pages.map((src, i) => (
            <figure key={i} className="overflow-hidden rounded-md bg-white shadow-sm ring-1 ring-slate-200">
              <img src={src} alt={`Página ${i + 1}`} className="block w-full" data-testid={`doc-preview-page-${i + 1}`} />
              <figcaption className="border-t border-slate-100 px-3 py-1.5 text-xs text-slate-500">Página {i + 1} de {pages.length}</figcaption>
            </figure>
          ))}
        </div>
      )}
    </DialogContent>
  </Dialog>
);
